if (!customElements.get('clover-ca-product-acknowledgement')) {
  customElements.define(
    'clover-ca-product-acknowledgement',
    class CloverCAProductAcknowledgement extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('[data-ca-acknowledgement-checkbox]');
        this.status = this.querySelector('[data-ca-acknowledgement-status]');
        this.form = this.closest('form');
        this.addButton = this.form?.querySelector('[name="add"]');
        this.variantInput = this.form?.querySelector('input[name="id"]');

        if (!this.checkbox || !this.form || !this.addButton) return;

        this.checkbox.addEventListener('change', () => this.updateGate());
        this.variantInput?.addEventListener('change', () => {
          window.setTimeout(() => this.updateGate(), 0);
        });

        this.buttonObserver = new MutationObserver(() => {
          if (!this.checkbox.checked && !this.addButton.disabled) this.lockButton();
        });
        this.buttonObserver.observe(this.addButton, { attributes: true, attributeFilter: ['disabled'] });

        this.updateGate();
      }

      disconnectedCallback() {
        this.buttonObserver?.disconnect();
      }

      selectedVariantAvailable() {
        const section = this.closest('section');
        const variantJson = section?.querySelector(
          'variant-selects script[type="application/json"], variant-radios script[type="application/json"]'
        );

        if (variantJson && this.variantInput?.value) {
          try {
            const variants = JSON.parse(variantJson.textContent);
            const selectedVariant = variants.find(
              (variant) => String(variant.id) === String(this.variantInput.value)
            );
            if (selectedVariant) return Boolean(selectedVariant.available);
          } catch (error) {
            console.warn('Unable to read product availability for the restricted-shipping acknowledgement.', error);
          }
        }

        return this.addButton.dataset.caVariantAvailable === 'true';
      }

      lockButton() {
        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-disabled', 'true');
        this.addButton.dataset.caGateLocked = 'true';
      }

      updateGate() {
        const acknowledged = this.checkbox.checked;
        const available = this.selectedVariantAvailable();

        this.classList.toggle('is-acknowledged', acknowledged);

        if (!acknowledged) {
          this.lockButton();
          if (this.status) this.status.textContent = 'Check the box to unlock Add to Cart.';
          return;
        }

        if (available) {
          if (this.addButton.dataset.caGateLocked === 'true') {
            this.addButton.disabled = false;
            this.addButton.removeAttribute('aria-disabled');
            this.addButton.dataset.caGateLocked = 'false';
          }
          if (this.status) this.status.textContent = 'Acknowledged. Add to Cart is now available.';
        } else if (this.status) {
          this.status.textContent = 'Acknowledged. Select an available option to add this item.';
        }
      }
    }
  );
}
